import { render, staticRenderFns } from "./ProjectItemStatusAuditLogsTab.vue?vue&type=template&id=054490a8&scoped=true&lang=html&"
import script from "./ProjectItemStatusAuditLogsTab.vue?vue&type=script&lang=ts&"
export * from "./ProjectItemStatusAuditLogsTab.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectItemStatusAuditLogsTab.vue?vue&type=style&index=0&id=054490a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054490a8",
  null
  
)

export default component.exports